const waterData = [
  {
    id: 1,
    data: [
      {
        type: "heading",
        content: "Water Helps Your Brain Shine Bright",
      },
      {
        type: "list",
        dataHeader:
          "Your brain is about 75% water—wow! So when you drink enough water, your brain can:",
        content: ["Think faster", "Focus better", "Feel less tired"],
      },
      {
        type: "para",
        content: [
          "A study from the University of East London (uel.ac.uk) found that kids who drank water before a test did better than those who didn't!",
          "Tip: Feeling foggy or grumpy? Drink a glass of water—it might be your brain asking for a refill.",
        ],
      },
    ],
  },
  {
    id: 2,
    data: [
      {
        type: "heading",
        content: "Water Keeps Your Heart and Muscles Pumping",
      },
      {
        type: "list",
        dataHeader:
          "Your blood is mostly water too! Water helps carry oxygen and nutrients all over your body, like a delivery truck on turbo-speed, also:",
        content: [
          "It keeps your heart beating steadily",
          "It boosts energy during play and sports",
          "It helps muscles move smoothly—no cramps or ouchies!",
        ],
      },
      {
        type: "para",
        content: [
          "Children's Hospital of Orange County (choc.org) says staying hydrated helps young athletes avoid muscle fatigue and stay strong during physical activity.",
        ],
      },
    ],
  },
  {
    id: 3,
    data: [
      {
        type: "heading",
        content: "Water Helps You Digest Like a Champion",
      },
      {
        type: "list",
        dataHeader: "After you eat, water helps your body:",
        content: [
          "Break down food",
          "Absorb nutrients",
          "Keep your tummy calm and your poop regular (yes, we said it!)",
        ],
      },
      {
        type: "para",
        content: [
          "Kids need fiber AND water to poop comfortably. Without enough water, your tummy might get a little stuck (that's called constipation).",
          "The American Academy of Pediatrics (aap.org) recommends water as the #1 drink to help kids stay regular and healthy.",
        ],
      },
    ],
  },
  {
    id: 4,
    data: [
      {
        type: "heading",
        content: "Water Keeps You Cool Like a Cucumber",
      },
      {
        type: "list",
        dataHeader:
          "When you play, run, or jump, your body heats up. Water helps you:",
        content: [
          "Sweat, which cools your skin",
          "Keep your body temperature just right—not too hot, not too cold",
        ],
      },
      {
        type: "para",
        content: [
          "According to Nationwide Children's Hospital (nationwidechildrens.org), proper hydration prevents heat exhaustion and keeps kids safe during exercise.",
        ],
      },
    ],
  },
  {
    id: 5,
    data: [
      {
        type: "heading",
        content: "Water is Your Body's Cleaning Crew",
      },
      {
        type: "list",
        dataHeader:
          "Water washes away waste and icky stuff from your body through:",
        content: [
          "Pee",
          "Sweat",
          "Tears (yes, even crying is part of the clean-up crew!)",
        ],
      },
      {
        type: "para",
        content: ["It's like giving your body a bath from the inside out."],
      },
    ],
  },
  {
    id: 6,
    data: [
      {
        type: "heading",
        content: "Water is Great for Skin, Eyes, and Joints",
      },
      {
        type: "list",
        dataHeader: "Drinking Adequate Water can help:",
        content: [
          "Makes skin soft and bouncy",
          "Keeps eyes moist and shiny",
          "Cushions your joints (like knees and elbows!) so you can move without pain",
        ],
      },
      {
        type: "para",
        content: [
          "Stanford Children's Health (stanfordchildrens.org) reminds us that dehydration can dry out your skin and slow you down.",
        ],
      },
    ],
  },
  {
    id: 7,
    data: [
      {
        type: "heading",
        content: "How Much Water Do Kids Need?",
      },
      {
        type: "list",
        dataHeader: "Here's a simple guide from Children's Hospital Colorado:",
        content: [
          "Ages 4-8: About 5 cups a day",
          "Ages 9-13: Around 7-8 cups",
          "More if you're running, sweating, or playing in the sun!",
        ],
      },
      {
        type: "para",
        content: [
          "Bonus tip: Eating water-rich foods like watermelon, strawberries, cucumbers, and oranges also counts!",
        ],
      },
    ],
  },
  {
    id: 8,
    data: [
      {
        type: "heading",
        content: "What Happens If You Don't Drink Enough Water?",
      },
      {
        type: "list",
        dataHeader: "If you're not getting enough, you might feel:",
        content: [
          "Thirsty and tired",
          "Dizzy or confused",
          "Headachy or cranky",
          "Your pee might turn dark yellow (light lemonade color is healthy!)",
        ],
      },
      {
        type: "para",
        content: [
          "That's your body's way of waving a red flag—(More water, please!)",
        ],
      },
    ],
  },
  {
    id: 9,
    data: [
      {
        type: "heading",
        content: "Choose Water Over Sugary Drinks",
      },
      {
        type: "list",
        dataHeader:
          "Soda, sports drinks, and even fruit juices can sneak in a lot of sugar. These can:",
        content: [
          "Harm your teeth",
          "Add too many empty calories",
          "Make you feel sluggish",
        ],
      },
      {
        type: "list",
        dataHeader: "Instead of soda, try:",
        content: [
          "Sparkling water with a splash of juice",
          "Water infused with strawberries, mint, or lemon",
          "Ice cubes shaped like stars—just for fun!",
        ],
      },
      {
        type: "para",
        content: [
          "The CDC (cdc.gov) says water is the healthiest beverage for kids, and sugary drinks should be limited.",
        ],
      },
    ],
  },
  {
    id: 10,
    data: [
      {
        type: "heading",
        content: "Final Splash: Water is Your Everyday Hero",
      },
      {
        type: "para",
        content: [
          "Water does so much and asks for so little. It's not fancy, it doesn't sparkle (unless you want it to), but it's the secret ingredient to staying happy, healthy, and ready to tackle your day.",
          "So drink up, water warriors!",
          "Stay strong, stay sharp, and keep your body fueled by nature's best drink.",
        ],
      },
      {
        type: "link",
        dataHeader: "Useful Resources",
        content: [
          {
            head: "About Water",
            body: "https://nutritionsource.hsph.harvard.edu/water/",
          },
          {
            head: "Dietary Reference Intakes for Water, Potassium, Sodium, Chloride, and Sulfate (2005) - Chapter: 4 Water",
            body: "https://nap.nationalacademies.org/read/10925/chapter/6",
          },
          {
            head: "Should children drink more water?",
            body: "https://www.sciencedirect.com/science/article/abs/pii/S0195666309000403",
          },
          {
            head: "Why Drinking Water Is the Way to Go",
            body: "https://kidshealth.org/en/kids/water.html",
          },
        ],
      },
    ],
  },
];

export default waterData;
